import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import baseURL from '../Common/Config';
import Axiosfetch from '../Common/Axiosfetch';
import Alert from 'react-s-alert';
import FailureAlert from '../Common/Failure';
import * as yup from 'yup';
import { CreateUser, EditUser, UploadUserPhoto } from '../Common/Services/UserService';
import { ValidateUser, CallBackAlert } from '../Common/Validations/validation';
import IsUndefinedNullOrEmpty from '../Common/Validations/valueCheck';

const User = {
    UserName: "",
    FirstName: "",
    LastName: "",
    EmailID: "",
    RoleID: "",
    OrganizationID: 0,
    PhoneNumber: 0,
    Password: "",
    IsNewUser: 0,
    UserType: 1,
    Photo: "",
    Status: 1,
    IsDeleted: 0
};

const UserSchema = yup.object().shape({
    RoleID: yup.string().required('Enter Valid Role').required(),
    EmailID: yup.string().trim().required().email(),
    LastName: yup.string().trim().required(),
    FirstName: yup.string().trim().required(),
    UserName: yup.string().trim().required(),
    PhoneNumber: yup.number().required(),
});

const AddUsers = ({ themeColor, hideuser, getUser, edit, userdetail, allUser }) => {

    const [userData, setUserData] = useState(User);
    const [Roles, setRoles] = useState([]);
    const [Organization, setOrganization] = useState([]);
    const [UserPhoto, setUserPhoto] = useState(null);

    const onTextChange = (e) => {
        let value = e.target.value;
        setUserData({ ...userData, [e.target.name]: value });
    };

    const onNumberChange = (e) => {
        let value = e.target.value;
        if (value !== "" && !isNaN(value)) {
            setUserData({ ...userData, [e.target.name]: parseFloat(value) });
        }
        else {
            setUserData({ ...userData, [e.target.name]: 0 });
        }
    };

    const SaveUser = () => {
        if (UserPhoto !== null) {
            UploadUserPhotoFile();
        }
        else {
            SaveUserDetails(null);
        }
    };

    const SaveUserDetails = (fileName) => {
        UserSchema.validate(userData).then(valid => {
            var user = userData;
            if (ValidateUser(user, edit, allUser)) {
                user.UserType = 1;
                user.Photo = (IsUndefinedNullOrEmpty(user.Photo)) ? (IsUndefinedNullOrEmpty(fileName) ? "" : fileName) : (fileName === null ? user.Photo : fileName);
                if ((parseInt(edit) === 0)) {
                    CreateUser(user, UserDetailsSuccess, Failure);
                }
                else {
                    EditUser(user, UserDetailsSuccess, Failure);
                }
            }
        }).catch(err => {
            Alert.error(err.message, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        });
    };

    const UploadUserPhotoFile = () => {
        let formData = new FormData();
        formData.append('file', UserPhoto);
        UploadUserPhoto(formData, userUploadSuccess, Failure);
    };

    const userUploadSuccess = (data) => {
        if (data.success) {
            SaveUserDetails(data.filename);
        }
        else {
            Alert.error(data.message, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const Failure = (err) => {
        FailureAlert(err);
    };

    const OnFileUpload = (e) => {
        var selectedFile = e.target.files[0];
        if (selectedFile.type === "image/jpeg" || selectedFile.type === "image/png" ||
            selectedFile.type === "image/jpg") {
            setUserPhoto(selectedFile);
        }
        else {
            Alert.error("File Type allowed are : PNG , JPG, JPEG", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const UserDetailsSuccess = (data) => {
        if (data.success) {
            hideuser();
            getUser();
        }

        CallBackAlert(data);
    };

    const UserRolesSuccess = (data) => {
        if (data.length > 0) {
            setRoles(data);
            Axiosfetch(baseURL + "GetActiveOrganizations", "GET", null, UserOrgSuccess, Failure);
        }
        else {
            setRoles([]);
        }
    };

    const UserOrgSuccess = (data) => {
        if (data.length > 0) {
            setOrganization(data);
        }
        else {
            setOrganization([]);
        }
    };

    useEffect(() => {
        if (parseInt(edit) === 1) {
            setUserData(userdetail);
        }

        Axiosfetch(baseURL + "GetActiveRoles", "GET", null, UserRolesSuccess, Failure);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div>
            <div id="addProduct" className="modal" style={{ display: "block", paddingTop: "40px" }}>
                <div className="modal-content">
                    <div className={`modal-header header-style align-center ${themeColor}`}>
                        <span style={{ marginLeft: "5px", padding: "5px" }}>{parseInt(edit) === 0 ? "Add" : "Edit"} User</span>
                        <span className="close" onClick={hideuser}>&times;</span>
                    </div>
                    <div style={{ height: "70vh", overflow: "auto", overflowX: "hidden" }}>
                        <table className="table">
                            <tbody>
                                <tr>
                                    <td>
                                        <h4>User Name<span className="mandatoryStar">*</span></h4>
                                    </td>
                                    <td>
                                        <input type="text" name="UserName"
                                            className="form-control"
                                            onChange={e => onTextChange(e)}
                                            value={userData.UserName}></input>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <h4>First Name<span className="mandatoryStar">*</span></h4>
                                    </td>
                                    <td>
                                        <input type="text" name="FirstName"
                                            className="form-control"
                                            onChange={e => onTextChange(e)}
                                            value={userData.FirstName}></input>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <h4>Last Name<span className="mandatoryStar">*</span></h4>
                                    </td>
                                    <td>
                                        <input type="text" name="LastName"
                                            className="form-control"
                                            onChange={e => onTextChange(e)}
                                            value={userData.LastName}></input>
                                    </td>
                                </tr>

                                {parseInt(edit) === 0 && (<tr>
                                    <td>
                                        <h4>Password<span className="mandatoryStar">*</span></h4>
                                    </td>
                                    <td>
                                        <input type="password" name="Password"
                                            className="form-control"
                                            onChange={e => onTextChange(e)}
                                            value={userData.Password}></input>
                                    </td>
                                </tr>)}
                                <tr>
                                    <td>
                                        <h4>Email ID<span className="mandatoryStar">*</span></h4>
                                    </td>
                                    <td>
                                        <input type="text" name="EmailID"
                                            className="form-control"
                                            onChange={e => onTextChange(e)}
                                            value={userData.EmailID}></input>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <h4>Phone Number<span className="mandatoryStar">*</span></h4>
                                    </td>
                                    <td>
                                        <input type="text" name="PhoneNumber"
                                            className="form-control"
                                            onChange={e => onNumberChange(e)}
                                            value={userData.PhoneNumber}></input>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <h4>User Photo</h4>
                                    </td>
                                    <td>
                                        <input type="file" name="Photo"
                                            className="form-control"
                                            onChange={e => OnFileUpload(e)}
                                            accept="image/jpeg, image/png"></input>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <h4>Organization</h4>
                                    </td>
                                    <td>
                                        <div className="basic-select">
                                            <select className="DropdownStyle" style={{ width: "95%" }} value={userData.OrganizationID} name="OrganizationID" onChange={(e) => onTextChange(e)}>
                                                <option value="0">Select Organization</option>
                                                {
                                                    Organization.length && Organization.map(Organization => (
                                                        <option key={Organization._id} value={Organization._id}>{Organization.Name}</option>
                                                    )
                                                    )
                                                }
                                            </select>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <h4>Role<span className="mandatoryStar">*</span></h4>
                                    </td>
                                    <td>
                                        <div className="basic-select">
                                            <select className="DropdownStyle" style={{ width: "95%" }} value={userData.RoleID} name="RoleID" onChange={(e) => onTextChange(e)}>
                                                <option value="0">Select Role</option>
                                                {
                                                    Roles.length && Roles.map(Role => (
                                                        <option key={Role._id} value={Role._id}>{Role.Name}</option>
                                                    )
                                                    )
                                                }
                                            </select>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan="2" style={{ textAlign: "right" }}>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <button type="button" style={{ fontSize: "1.4rem" }} className={`btn btn-Save ${themeColor}Focus`} onClick={SaveUser}>Save</button>
                                                <button type="button" className="btn btn-default" onClick={hideuser}>Close</button>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddUsers;
